import React, { useState, useEffect } from "react";
import styles from "../Login/login.module.css";
import styles2 from "../UserDetails/userDetails.module.css";
import { AiFillLock, AiOutlineUser } from "react-icons/ai";
import axios from "axios";
import Logo from "../assets/logo-with-text.svg";
import BgAnimation from "../assets/bg-animation2.mp4";

const ResetPassowrd = () => {
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");
  const [confirmPassowrd, setConfirmPassword] = useState("");
  const [showMsg, setShowMsg] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [errorShow, setErrorShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (password !== confirmPassowrd) {
      setErrorShow(true);
      setError("Password and Confirm Password does not match.");
    } else {
      setIsLoading(true);
      let data = JSON.stringify({
        username: username,
        password: password,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://server.anshfintech.com/api/user/update-password",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          setShow(true);
          setShowMsg("Your password has been successfully updated.");
        })
        .catch((error) => {
          console.log(error);
          setErrorShow(true);
          setError("Failed to update password. Please try again.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (show) {
      setShow(true);
      const toRef = setTimeout(() => {
        setShow(false);
        setPassword("");
        setConfirmPassword("");
        setUserName("");
        clearTimeout(toRef);
      }, 4000);
    }
  }, [show]);

  useEffect(() => {
    if (errorShow) {
      setErrorShow(true);
      const toRef = setTimeout(() => {
        setErrorShow(false);
        clearTimeout(toRef);
      }, 2000);
    }
  }, [errorShow]);

  return (
    <div className={`relative flex flex-col items-center lg:space-y-0 lg:flex-row min-h-screen w-full lg:items-center justify-center px-6 md:px-10 lg:px-0`}>
      <div>
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          webkit-playsinline="true"
          className="absolute inset-0 w-full h-full object-cover z-0 backdrop-blur-md"
          poster={BgAnimation}
        >
          <source src={BgAnimation} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 w-full h-full bg-black opacity-20 z-0"></div>
      </div>
      <div className="relative z-10 w-full md:w-auto rounded-[12px] md:rounded-[26px] shadow-custom-inner bg-gradient-to-br from-[#ffffff]/5 via-[#8BD89500] to-[#8BD89500] p-[1.5px]">
        <div className={` ${styles.loginBackground} w-full h-full flex flex-col p-[20px] md:p-[60px] rounded-[12px] md:rounded-[26px] shadow-custom-inner backdrop-blur-custom bg-transparent`}>
          <div className={`w-full flex items-center justify-center text-[24px] lg:text-[50px] lg:leading-[48px] font-bold font-poppins text-[#ffffff]  `}>
            <img src={Logo} alt="logo" className="w-[100px] md:w-[160px] lg:w-[220px]" />
          </div>
          <div className={`text-center text-[20px] mt-5 lg:text-[28px] lg:leading-[24px] font-medium lg:mt-[30px] text-[#ffffff]`}>
            Reset your Password
          </div>
          <div className={`text-center text-[11px] mt-1 lg:text-[14px] lg:leading-[32px] font-normal lg:mt-[6px] text-[#ffffffcc]`}>
            Last 3 passwords are not allowed.
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiOutlineUser className={`ml-4 w-5 h-5  text-[#FFCF2C]`} />
            <input
              type="text"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="username"
              className={styles.logininput}
            />
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiFillLock className={`ml-4 w-5 h-5  text-[#FFCF2C]`} />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password"
              className={styles.logininput}
            />
          </div>
          <div className={`flex items-center mt-[40px] bg-[#ffffff0a] rounded-[6px]`}>
            <AiFillLock className={`ml-4 w-5 h-5  text-[#FFCF2C]`} />
            <input
              type="password"
              value={confirmPassowrd}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm password"
              className={styles.logininput}
            />
          </div>
          {errorShow ? (
            <div className={`ml-4 ${styles.errorMsg}`}>{error}</div>
          ) : null}
          {show === true ? (
            <div className={styles2.successMsg}>{showMsg}</div>
          ) : null}
          <button 
            className={`${styles.loginButton} w-full relative`} 
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              "Reset Password"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassowrd;
